<template>
  <div :class="interviewWrapperClasses">
    <Transition name="fade-in">
      <interview-nav v-show="showNav" :touch-and-validate="touchAndValidate" />
    </Transition>
    <div class="interview-header-toolbar">
      <Transition name="fade-in">
        <help-request-button v-if="showHelpButton && showNav" class="interview-help-btn-global" />
      </Transition>
    </div>
    <autosave-bar />
    <div :class="mainContentClasses">
      <slot name="default"></slot>
    </div>
    <PageFooter v-if="showFooter" />
  </div>
</template>

<script>
  import InterviewNav from '@/components/InterviewNav.vue';
  import AutosaveBar from '@/components/AutosaveBar.vue';
  import PageFooter from '@/components/PageFooter.vue';
  import HelpRequestButton from '@/components/HelpRequestButton.vue';

  export default {
    components: {
      InterviewNav,
      AutosaveBar,
      PageFooter,
      HelpRequestButton
    },
    props: {
      // Add default padding to the main content (default) slot.
      // Set to false when you want to handle sidebar padding in the slot content.
      paddingMainY: {
        type: Boolean,
        default: true
      },
      paddingMainX: {
        type: Boolean,
        default: true
      },
      itemsCenter: {
        type: Boolean,
        default: true
      },
      showNav: {
        type: Boolean,
        default: true
      },
      showHelpButton: {
        type: Boolean,
        default: false
      },
      standardBackground: {
        type: Boolean,
        default: true
      },
      touchAndValidate: {
        type: Function,
        default: null
      },
      showFooter: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      interviewWrapperClasses() {
        return {
          'interview-wrapper': true,
          'wrapper-bg-std': this.standardBackground
        }
      },
      mainContentClasses() {
        return {
          'main-content': true,
          'main-content-padding-y': this.paddingMainY,
          'main-content-padding-x': this.paddingMainX,
          'main-content-items-center': this.itemsCenter
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .interview-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    &.wrapper-bg-std {
      background-color: $std-background;
    }
  }

  .interview-header-toolbar {
    position: relative;
    width: 100%;
    min-height: 0;
    z-index: 1002;
  }
  .interview-help-btn-global {
    position: absolute;
    top: 32px;
    right: 32px;
    min-width: 180px;
    z-index: 1002;
  }
  @media (max-width: 600px) {
    .interview-header-toolbar {
      position: static;
      width: 100%;
      min-height: 0;
    }
    .interview-help-btn-global {
      position: static;
      min-width: 100%;
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      right: auto;
      top: auto;
      transform: none;
    }
  }

  .main-content {
    display: flex;
    flex: 1;
    justify-content: center;
    &.main-content-items-center {
      align-items: center;
    }
          
    &.main-content-padding-y {
      padding-top: map-get($spacers, 5);
      padding-bottom: map-get($spacers, 5);
    }
    &.main-content-padding-x {
      padding-left: map-get($spacers, 5);
      padding-right: map-get($spacers, 5);

      @include media-breakpoint-down(md) {
        padding-left: map-get($spacers, 2);
        padding-right: map-get($spacers, 2);
      }
    }
  }
</style>